import { SystemOrganizationInsert, SystemOrganizationDelete, SystemOrganizationUpdate, SystemOrganizationGetById, SystemOrganizationGetList, SystemOrganizationGetPageList } from "@/api/systemorganization/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 新增
    SystemOrganizationInsert(context, payload) {
        return new Promise((resolve, reject) => {
            
            
            SystemOrganizationInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    SystemOrganizationUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            SystemOrganizationUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    SystemOrganizationGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            SystemOrganizationGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    SystemOrganizationGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            SystemOrganizationGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    SystemOrganizationGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            SystemOrganizationGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}